import { useCallback } from 'react';
import type { IBusiness, IContact } from '@trii/types/dist/Contacts/contacts';

type Entity = IContact | IBusiness | null;

type UseEntityUpdateSyncArgs = {
  entity: Entity;
  setEntity: (next: IContact | IBusiness | null) => void;
};

export const useEntityUpdateSync = ({ entity, setEntity }: UseEntityUpdateSyncArgs) => {
  const handleEntityUpdated = useCallback(
    (update: unknown) => {
      if (!update || typeof update !== 'object') {
        return;
      }

      const updateObj = update as Record<string, unknown>;

      if ('id' in updateObj) {
        // Full entity replacement
        setEntity(update as IContact | IBusiness);
        return;
      }

      if (!entity) {
        return;
      }

      // Shallow merge partial updates into existing entity
      const merged = { ...(entity as any), ...updateObj };
      setEntity(merged as IContact | IBusiness);
    },
    [entity, setEntity],
  );

  return handleEntityUpdated;
};
